import Http from "@/global/axios";

export const getGoodsDetail = (params) => new Http().require({ api: { controller: 'shop', action: 'detail' }, param: params });
export const getDescription = (params) => new Http().require({ api: { controller: 'shop', action: 'getDescription' }, param: params });

// 20191224 增加浏览量
export const addNum = (params) => new Http().require({ api: { controller: 'shop', action: 'addNum' }, param: params });